'use client';

import { ContentfulLivePreview } from '@contentful/live-preview';
import { ContentfulLivePreviewProvider } from '@contentful/live-preview/react';
import { useEffect } from 'react';

export default function PreviewProvider({
  children,
  locale = 'da-DK',
  space,
  environment,
}: {
  children: React.ReactNode;
  locale?: string;
  space?: string;
  environment?: string;
}) {
  const urlEnvironment =
    typeof window === 'undefined'
      ? undefined
      : new URLSearchParams(window.location.search).get('env_id') ?? undefined;
  const effectiveEnvironment =
    urlEnvironment && /^[A-Za-z0-9_-]+$/.test(urlEnvironment)
      ? urlEnvironment
      : environment;

  useEffect(() => {
    ContentfulLivePreview.init({
      locale,
      space,
      environment: effectiveEnvironment,
      enableInspectorMode: true,
      enableLiveUpdates: true,
      debugMode: false,
      targetOrigin: ['https://app.contentful.com', 'https://app.eu.contentful.com', 'https://be.contentful.com'],
    });
  }, [locale, space, effectiveEnvironment]);

  return (
    <ContentfulLivePreviewProvider
      locale={locale}
      space={space}
      environment={effectiveEnvironment}
      enableInspectorMode={true}
      enableLiveUpdates={true}
      debugMode={false}
      targetOrigin={['https://app.contentful.com', 'https://app.eu.contentful.com', 'https://be.contentful.com']}
    >
      {children}
    </ContentfulLivePreviewProvider>
  );
}
